import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { } from '@angular/platform-browser';

@Component({
  selector: 'ao-loadding',
  templateUrl: './loadding.component.html',
  styleUrls: ['./loadding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaddingComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {

  }

}
